<div class="col-md-12">
  <!-- BUSCADOR -->
  <div class="mb-3">
    <mat-icon class="icon-c-folder icon-search"> search </mat-icon>
    <div class="col-12 row mt-2">
      <div class="col-sm-12 col-md-10 search-input">
        <input 
          matInput 
          (keyup)="filterByModule($event)" 
          class="form-control form-create" 
          placeholder="Buscar" 
          style="padding-left: 42px;"
          #input
        >
      </div>
    </div>
  </div>
  <!-- CARD -->
  <div class="card custom-inner-card mt-4">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-12">
              Acceso a {{ permissionsAdded.length }} módulos 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="overflow: auto; height: 500px;">
      <div class="row">
        <div class="col-md-12" style="padding-left: 4px;">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
              <button type="button" mat-icon-button style="background-color: #fff; border: none;" disabled></button>
              <mat-checkbox 
                class="checklist-leaf-node" 
                [checked]="checklistSelection.isSelected(node)" 
                (change)="todoLeafItemSelectionToggle(node);" 
                [disabled]="node.idUdn == 44" 
                >
                <div class="row">
                  <img class="list-image" src="{{node.icon}}" (error)="handleMissingImage(node)"/> 
                  {{ node.idPermission }} - {{ node.item }}
                </div>
              </mat-checkbox>
            </mat-tree-node>
        
            <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding></mat-tree-node>
            <mat-tree-node #tree *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
              <button 
                type="button" 
                mat-icon-button 
                matTreeNodeToggle 
                style="background-color: #fff; border: none;"
                (click)="$event.preventDefault()"
              >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              
              <mat-checkbox 
                [checked]="treeControl.dataNodes && descendantsAllSelected(node)" 
                [indeterminate]="treeControl.dataNodes && descendantsPartiallySelected(node)" 
                (change)="todoItemSelectionToggle(node)"
                [disabled]="node.idUdn == 44" 
                >
                <div class="row">
                  <img class="list-image" [src]="node.icon"/> 
                  {{ node.idPermission }} - {{ node.item }}
                </div>
              </mat-checkbox>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <strong class="subtitle-tree mt-3">Modulos de grupo Elektra</strong> -->
<!-- [disabled]="node.idUdn == 44"  -->


